// Proposal-back share URL builders. Two URLs:
//
//   1. **Share URL** — `/proposal-back/<proposalPubkey>?u=&a=&o=&v=`. Short,
//      OG-friendly. The `app/[locale]/proposal-back/[proposalPubkey]/page.tsx`
//      route owns this URL, emits OG metadata for crawlers, and
//      bounces the user to the canonical proposal URL on the client.
//   2. **Canonical URL** — `/proposals/<proposalPubkey>`. The actual
//      page where the user lands after the share-link redirect.
//
// Backer context (raw amount, display amount, analytics outcome, user) is encoded in the share URL's
// query string because there's no `getProposalBacker` SDK endpoint —
// the page reads its own search params and passes them through to
// `buildOgMetadata`.

const PROPOSAL_BACK_SHARE_PATH_PREFIX = '/proposal-back';
const LAUNCHPAD_PATH_PREFIX = '/proposals';

export interface BuildProposalBackShareUrlContext {
  userPubkey: string;
  /** D6-encoded USDC amount as a string (BigInt-safe). */
  amountD6: string;
  /** Amount formatted in the user's selected display currency. */
  displayAmount: string;
  outcomeIndex: number;
}

/** Relative share-link path with backer context encoded as query params. */
export function buildProposalBackShareUrl(
  proposalPubkey: string,
  ctx: BuildProposalBackShareUrlContext,
): string {
  const qs = new URLSearchParams({
    u: ctx.userPubkey,
    a: ctx.amountD6,
    o: ctx.outcomeIndex.toString(),
    v: ctx.displayAmount,
  });
  return `${PROPOSAL_BACK_SHARE_PATH_PREFIX}/${proposalPubkey}?${qs.toString()}`;
}

/** Relative canonical path the share page redirects to. */
export function buildProposalBackCanonicalUrl(proposalPubkey: string): string {
  return `${LAUNCHPAD_PATH_PREFIX}/${proposalPubkey}`;
}
